import { render } from "./MobileNo.vue?vue&type=template&id=4f83d013&scoped=true"
import script from "./MobileNo.vue?vue&type=script&lang=js"
export * from "./MobileNo.vue?vue&type=script&lang=js"

import "./MobileNo.vue?vue&type=style&index=0&id=4f83d013&scoped=true&lang=css"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f83d013"]])

export default __exports__